export default __webpack_public_path__ + "static/media/ic-students.56cb6a0c.svg";